import { render, staticRenderFns } from "./BlockTopMessage.vue?vue&type=template&id=3da8d2c6&scoped=true&"
import script from "./BlockTopMessage.vue?vue&type=script&lang=ts&"
export * from "./BlockTopMessage.vue?vue&type=script&lang=ts&"
import style0 from "./BlockTopMessage.vue?vue&type=style&index=0&id=3da8d2c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da8d2c6",
  null
  
)

export default component.exports